import TimeSeriesScatterPlot from './TimeSeriesScatterPlot.json';
import ThreeDScatterPlot from './3DScatterPlot.json';

export default [TimeSeriesScatterPlot, ThreeDScatterPlot];
